import React from 'react';
import classNames from 'classnames';

type StylishNewButtonProps = {
  className?: string;
  customButton?: boolean;
  id?: string;
  children?: React.ReactNode;
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const StylishNewButton = React.forwardRef<
  HTMLButtonElement,
  StylishNewButtonProps
>((props, ref) => {
  const { className, customButton, id, children, disabled, ...rest } = props;
  const builtClassName = classNames(
    {
      button: !customButton,
      'button--primary':
        !customButton &&
        !className?.match(/--(primary|secondary|tertiary|icon)/g),
    },
    className
  );

  return (
    <button
      id={id}
      className={builtClassName}
      disabled={disabled}
      type="button"
      {...rest}
      ref={ref}
    >
      {children}
    </button>
  );
});

StylishNewButton.displayName = 'StylishNewButton';
export { StylishNewButton };
